import React, { Component } from 'react'
import classnames from 'classnames'
import { Col, Row } from 'react-flexbox-grid'
import Card from '@material-ui/core/Card'
import { withStyles } from '@material-ui/core/styles'
import Columns from '../../styles/columns'
import CardStyles from '../../styles/cards'
import NgrxDate from '../../util/NgrxDateHelper'
import NgrxUtil from '../../util/NgrxUtils'
import TitledLabel from '../../controls/TitledLabel'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'
import { localize } from '../../util/Localizer'
import Tooltip from '../../controls/Tooltip'
import { Colors } from '../../theme'
import Config from '../../Config'

class MemberSummary extends Component {
  pushToSummary () {
    document.location = '/UserProfile'
  }

  render () {
    const { classes = {} } = this.props
    const add = this.props.memberSummary.address
    const { showPhoneNumbers } = Config

    // make sure there is a member address
    let memberAddress = ''
    if (add) {
      memberAddress = (<div>{add.addressLine1}<br />{add.city} {add.province}<br />{add.postalCode}</div>)
    }

    return (
      <div>
        <h4 className='sectionHeading'>{localize('pages.memberSummary.profileHeader')}</h4>
        <Card className={ classnames(classes.summaryCard, classes.baseCard) }>
          <Row>
            <Col {...Columns.max6}>
              <TitledLabel title='pages.cardDetails.status' format='text' value={this.props.memberSummary.status} />
            </Col>
            {!Config.member.benefits.hideCoverage && <Col {...Columns.max6}>
              <TitledLabel title='pages.cardDetails.coverageDate' format='text' value={NgrxDate.SetDate(this.props.memberSummary.coverageEffectiveDate)} />
            </Col>}
            {!Config.member.benefits.hideExpiryDate && <Col {...Columns.max6}>
              <TitledLabel title='pages.cardDetails.coverageExp' format='text' value={NgrxDate.SetDate(this.props.memberSummary.coverageExpiryDate)} />
            </Col>}
            <Col {...Columns.max6}>
              <TitledLabel title='pages.cardDetails.birthDate' format='text' value={NgrxDate.SetDate(this.props.memberSummary.birthDate)} />
            </Col>
            <Col {...Columns.max6}>
              <TitledLabel title='pages.cardDetails.prefLanguage' format='text' value={this.props.memberSummary.preferedLanguage} />
            </Col>
          </Row>
        </Card>
        <h4 className='sectionHeading'>{localize('pages.memberSummary.contactHeader')}</h4>
        <Card className={ classnames(classes.summaryCard, classes.baseCard) }>
          <Row>
            <Col {...Columns.max6}>
              <TitledLabel title='pages.cardDetails.address' format='text' value={memberAddress} />
            </Col>
            { showPhoneNumbers &&
            <Col {...Columns.max6}>
              <TitledLabel title='pages.cardDetails.homePhone' format='text' value={NgrxUtil.formatPhoneNumber(this.props.memberSummary.phones)} />
            </Col> }
            { showPhoneNumbers &&
            <Col {...Columns.max6}>
              <TitledLabel title='pages.cardDetails.office' format='text' value={NgrxUtil.formatPhoneNumber(this.props.memberSummary.officePhone)} />
            </Col>}
            <Col {...Columns.max3} className='emailTooltipContainer'>
              <TitledLabel
                id='memberEmail'
                format='text'
                title={localize('pages.cardDetails.email')}
                value={(
                  <p>
                    {(() => {
                      if (Config.useSSO === false) {
                        return (
                          <a role='link' aria-labelledby={localize('pages.ariaLabelledBy.email')} className='editEmailLink' onClick={this.pushToSummary}>
                            {this.props.memberSummary.email}
                          </a>
                        )
                      } else {
                        return this.props.memberSummary.email
                      }
                    })()}
                  </p>
                )}
              />
              {(Config.useSSO === false) && (
                <Tooltip title={localize('pages.memberSummary.tooltip.changeEmail')} placement="right">
                  <IconButton tabIndex={-1} className='tooltip emailTooltip'>
                    <Icon color="inherit" style={{ fontSize: 20, color: Colors.Palette.primaryTextColor }}>info</Icon>
                  </IconButton>
                </Tooltip>
              )}
            </Col>
          </Row>
        </Card>
      </div>
    )
  }
}

const styles = {
  ...CardStyles
}

export default withStyles(styles)(MemberSummary)



// WEBPACK FOOTER //
// ./src/widgets/Member/MemberSummary.js